/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Query } from '@apollo/client/react/components';
import { gql } from '@apollo/client';
import { object, shape, string } from 'prop-types';
import mbpLogger from '@module-logger/mbp';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { GRAPHQL_ENV } from '../../../gql';
import * as app from '../../../../state/ducks/App';
import PromoCodeBlock from './PromoCodeBlock';
import { trackPage } from '../../../helpers/tracking/common/commonTrackingHelpers';
import withPageView from '../../../helpers/tracking/hocs/withPageView';

const brandSelectors = app.ducks.brand.selectors;
// TODO make the Promo code dynamic
const PromoCodePage = ({ brand, page }) => {
    const { contentType } = page;
    const PROMOCODEPAGE_QUERY = gql`
    query PromoCodeQuery {
        findContent(brand: "${brand['domain-name']}", environment: "${GRAPHQL_ENV}", contentType: "${contentType}", query: "{title : Promo Codes}") {
            content
        }
    }`;

    return (
        <Query query={PROMOCODEPAGE_QUERY}>
            {({ loading, error, data }) => {
                if (loading) {
                    return <div style={{ height: '80vh' }} />; // prevent header and footer from snapping together
                }
                if (error) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        query: PROMOCODEPAGE_QUERY,
                        component: 'PromoCodePage.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }
                if (!data) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: PROMOCODEPAGE_QUERY,
                        component: 'PromoCodePage.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                if (!data.findContent.content) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: PROMOCODEPAGE_QUERY,
                        component: 'PromoCodePage.js',
                        message: 'No content returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                const PromoCodeBlocks = data?.findContent?.content?.entries?.find((block) => block?.url === page?.path);
                return (
                    <>
                        <PromoCodeBlock block={PromoCodeBlocks} brand={brand} page={page} />
                    </>
                );
            }}
        </Query>
    );
};

PromoCodePage.propTypes = {
    brand: object.isRequired,
    page: shape({
        contentType: string.isRequired,
    }).isRequired,
};

const mapStateToProps = (state) => ({
    brand: brandSelectors.getBrand(state),
});

const enhance = compose(
    trackPage({
        type: 'template_page_promo_codes',
        name: 'Template Page Promo Codes',
        pageType: 'template_page_promo_codes',
        pageName: 'Template Page Promo Codes',
    }),

    withPageView({
        pageViewSuccessTest: () => true,
        updateEveryRender: true,
    }),
    connect(mapStateToProps),
);

export default enhance(PromoCodePage);
